function Footer() {
  return (
    <section id="footer" className="pb-5">
      <div className="footer-element">Built by John Davies, inspired by Brittany Chiang.
      </div>
    </section>
  )
}

export default Footer